/**
 * Парсит строку координат в различных форматах
 * Поддерживаемые форматы:
 * - "55.75, 37.62" (запятая как разделитель)
 * - "55.75 37.62" (пробел как разделитель)
 * - "55.75,37.62" (запятая без пробела)
 * - "37.62, 55.75" (долгота, широта - попытаемся определить)
 *
 * @param {string} input - Строка с координатами
 * @returns {object|null} - Объект {lng, lat} если валидны, иначе null
 */
export function parseCoordinates (input) {
    if (!input || typeof input !== 'string') {
        return null;
    }

    // Убираем лишние пробелы в начале и конце
    const trimmedInput = input.trim();
    // Пытаемся разделить по запятой или пробелу
    const parts = trimmedInput.split(/[,\s]+/).filter(p => p.length > 0);

    // Должно быть ровно 2 координаты
    if (parts.length !== 2) {
        return null;
    }

    // Пытаемся спарсить как числа
    const coord1 = parseFloat(parts[0]);
    const coord2 = parseFloat(parts[1]);

    if (isNaN(coord1) || isNaN(coord2)) {
        return null;
    }

    // Проверяем валидность координат
    // Широта: -90 до 90
    // Долгота: -180 до 180

    // Вариант 1: Первая координата - широта (широта, долгота)
    if (coord1 >= -90 && coord1 <= 90 && coord2 >= -180 && coord2 <= 180) {
        return {
            lat: coord1,
            lng: coord2,
        };
    }

    // Вариант 2: Первая координата - долгота (долгота, широта)
    if (coord2 >= -90 && coord2 <= 90 && coord1 >= -180 && coord1 <= 180) {
        return {
            lat: coord2,
            lng: coord1,
        };
    }

    // Не удалось распарсить
    return null;
}

/**
 * Форматирует координаты для отображения в UI
 *
 * @param {object} coords - Объект {lng, lat}
 * @returns {string} - Отформатированная строка
 */
export function formatCoordinates (coords) {
    if (!coords || !coords.lng || !coords.lat) {
        return '';
    }

    return `${coords.lat.toFixed(4)}, ${coords.lng.toFixed(4)}`;
}
